<template>
  <div class="dashboard-container">
    <!-- 顶部标题栏 -->
    <div class="header">
      <div class="header-left">
        <!-- 返回主页按钮 -->
        <div class="back-home-btn" @click="goToHome">
          <span class="back-icon">←</span>
          <span class="back-text">返回主页</span>
        </div>
        <!-- <div class="project-total">托管项目总数量：{{ elevatorStats.total }}</div> -->
        <div class="search-dropdown" v-click-outside="closeDropdown">
          <input
            type="text"
            v-model="searchKeyword"
            placeholder="搜索项目..."
            class="search-input"
            @focus="showDropdown = true"
            @input="filterOptions"
          />
          <span class="dropdown-icon">▼</span>
          <div class="dropdown-list" v-show="showDropdown && filteredOptions.length > 0">
            <div
              class="dropdown-item"
              v-for="item in filteredOptions"
              :key="item.id"
              @click="selectOption(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>

      <div class="title">海康智慧电梯托管监测平台</div>

      <div class="header-right">
        <!-- 楼层选择器 -->
        <div class="floor-selector-header">
          <div class="floor-control-group-header">
            <div class="custom-select-header">
              <select
                v-model="selectedDoorId"
                class="floor-dropdown-header"
                @change="handleHeaderFloorChange"
              >
                <option value="">选择楼层</option>
                <option v-for="floor in doorList" :key="floor.id" :value="floor.id">
                  {{ floor.name }}层
                </option>
              </select>
              <div class="select-arrow-header">▼</div>
            </div>
            <button
              class="confirm-btn-header"
              @click="confirmHeaderFloorSelection"
              :disabled="!selectedDoorId"
            >
              确定
            </button>
          </div>
        </div>
        <!-- 时间检索组件 -->
        <div class="time-filter">
          <!-- <div class="filter-label">数据时间：</div> -->
          <!-- <div class="date-picker-container">
            <input type="date" v-model="selectedDate" @change="onDateChange" class="date-picker" />
          </div> -->
        </div>
        <div class="current-time">北京时间：{{ currentTime }}</div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 左侧区域 -->
      <div class="left-section">
        <!-- 统计数据和饼图 -->
        <TriggerEventsStats :stats="elevatorStats">
          <template #pie-chart>
            <div id="pieChart" style="width: 100%; height: 100%"></div>
          </template>
        </TriggerEventsStats>

        <!-- 中心区域电梯实时状态监控 -->
        <div class="elevator-status-container">
          <div class="elevator-status-title">电梯实时状态监控</div>
          <div class="elevator-status-content">
            <div class="elevator-status-item">
              <div class="elevator-label">电梯楼层：</div>
              <div class="elevator-value">
                {{ communityNow.elevnum ? communityNow.elevnum + "层" : "1层" }}
              </div>
            </div>
            <div class="elevator-status-item">
              <div class="elevator-label">运行方向：</div>
              <div class="elevator-value">{{ communityNow.direction || "静止" }}</div>
            </div>
            <div class="elevator-status-item">
              <div class="elevator-label">平层状态：</div>
              <div class="elevator-value">{{ communityNow.flatStatus || "平层" }}</div>
            </div>
            <div class="elevator-status-item">
              <div class="elevator-label">运行速度：</div>
              <div class="elevator-value">{{ communityNow.speed || "0m/s" }}</div>
            </div>
            <div class="elevator-status-item">
              <div class="elevator-label">运行次数：</div>
              <div class="elevator-value">{{ communityNow.acelevtimes || 0 }}次</div>
            </div>
            <div class="elevator-status-item">
              <div class="elevator-label">开门次数：</div>
              <div class="elevator-value">{{ communityNow.acopentimes || 0 }}次</div>
            </div>
            <div class="elevator-status-item">
              <div class="elevator-label">运行里程：</div>
              <div class="elevator-value">{{ communityNow.acmile || "0公里" }}</div>
            </div>
            <div class="elevator-status-item">
              <div class="elevator-label">运行时间：</div>
              <div class="elevator-value">{{ communityNow.actime || 0 }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间视频播放器 -->
      <div class="center-section">
        <VideoPlayer
          :video-url="videoUrl"
          :door-list="doorList"
          :radio-id="String($route.params.id || '')"
          @floor-change="handleFloorChange"
        />
      </div>

      <!-- 右侧区域 -->
      <div class="right-section">
        <!-- 维保作业记录 -->
        <MaintenanceRecords
          :records="maintenanceRecords"
          :container-style="{ height: '48%' }"
        />

        <!-- 工单记录 -->
        <WorkOrderRecords
          :records="workOrderRecords"
          :container-style="{ height: '48%', marginTop: '20px' }"
        />
      </div>
    </div>

    <!-- 底部区域 -->
    <div class="bottom-section">
      <!-- 设备信息 -->
      <div class="device-info">
        <div class="device-title">设备信息</div>
        <div class="device-content" v-if="deviceInfo">
          <div class="device-item" v-for="(value, key) in deviceDisplayInfo" :key="key">
            <span class="device-label">{{ key }}：</span>
            <span class="device-value">{{ value }}</span>
          </div>
        </div>
        <div class="device-empty" v-else>暂无设备信息</div>
      </div>

      <!-- 报警记录 -->
      <AlarmRecords :records="alarmRecords" />

      <!-- 维保计划展示 -->
      <div class="maintenance-plan-section">
        <div class="maintenance-plan-title">维保信息/计划/人员</div>
        <div
          class="maintenance-content"
          v-if="maintenancePlans && maintenancePlans.length > 0"
        >
          <div
            class="maintenance-item"
            v-for="(value, key) in maintenancePlanDisplayInfo"
            :key="key"
          >
            <span class="maintenance-label">{{ key }}：</span>
            <span class="maintenance-value">{{ value }}</span>
          </div>
        </div>
        <div class="device-empty" v-else>暂无维保计划</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { dashboardAPI } from "@/api/dashboard";
import VideoPlayer from "@/components/VideoPlayer.vue";
import TriggerEventsStats from "@/components/TriggerEventsStats.vue";
import WorkOrderRecords from "@/components/WorkOrderRecords.vue";
import AlarmRecords from "@/components/AlarmRecords.vue";
import MaintenanceRecords from "@/components/MaintenanceRecords.vue";

export default {
  name: "HomeView",
  components: {
    VideoPlayer,
    TriggerEventsStats,
    WorkOrderRecords,
    AlarmRecords,
    MaintenanceRecords,
  },
  data() {
    return {
      currentTime: "",
      timer: null,
      dataRefreshTimer: null,
      doorList: [],
      // 楼层选择相关
      selectedDoorId: "",
      // 下拉搜索相关
      searchKeyword: "",
      showDropdown: false,
      filteredOptions: [],
      // 时间检索相关
      selectedDate: this.formatDate(new Date()),
      selectedFilter: "today",
      // 所有数据将通过API请求获取
      elevatorStats: {
        total: 0,
        thisYearMaintenance: 0,
        lastYearMaintenance: 0,
        totalEvents: 0,
      },
      pieChartData: [],
      barChartData: [],
      lineChartData: [],
      barHorizontalChartData: [],
      maintenanceRecords: [],
      workOrderRecords: [],
      alarmRecords: [],
      platformButtons: [],
      // 设备信息
      deviceInfo: null,
      // 视频流URL
      videoUrl: "",
      // 项目列表数据（下拉框数据源）
      communityData: [],
      // API原始数据
      apiData: null,
      // 电梯实时状态数据
      communityNow: {},
      // 维保计划数据
      maintenancePlans: [],
      // 图表实例缓存
      charts: {
        pie: null,
        bar: null,
        line: null,
        barHorizontal: null,
      },
    };
  },
  computed: {
    // 格式化设备信息用于显示
    deviceDisplayInfo() {
      if (!this.deviceInfo) return {};
      const labelMap = {
        device_code: "设备代码",
        elevator_sign: "使用登记",
        elevator_unit: "制造单位",
        elevator_number: "电梯工号",
        elevator_model: "电梯型号",
        elevator_layer: "电梯层站",
        inspection_organization: "检验机构",
        audittimes: "年审月份",
      };

      const result = {};
      for (const [key, value] of Object.entries(this.deviceInfo)) {
        const label = labelMap[key] || key;
        if (value !== null && value !== undefined && value !== "") {
          result[label] = value;
        }
      }
      return result;
    },
    // 格式化维保计划信息用于显示
    maintenancePlanDisplayInfo() {
      if (!this.maintenancePlans || this.maintenancePlans.length === 0) return {};
      const plan = this.maintenancePlans[0];
      const labelMap = {
        unit_name: "维保单位",
        phone: "联系电话",
        number: "96333编号",
        last_maintenance: "上一次维保",
        next_maintenance: "下一次维保",
        communityName: "项目地址",
        maintenanceWorkerName1: "维保师傅1",
        maintenanceWorkerName2: "维保师傅2",
      };

      const result = {};
      for (const [key, value] of Object.entries(plan)) {
        const label = labelMap[key] || key;
        if (value !== null && value !== undefined && value !== "") {
          result[label] = value;
        }
      }
      return result;
    },
  },
  directives: {
    "click-outside": {
      bind(el, binding) {
        el._clickOutside = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener("click", el._clickOutside);
      },
      unbind(el) {
        document.removeEventListener("click", el._clickOutside);
      },
    },
  },
  watch: {
    // 监听路由参数变化，刷新数据
    "$route.params.id": {
      handler(newId, oldId) {
        if (newId !== oldId) {
          console.log("路由id变化:", oldId, "->", newId);
          // 重置数据
          this.videoUrl = "";
          this.deviceInfo = null;
          // 重新获取数据
          this.fetchAllData();
        }
      },
      immediate: false,
    },
    // 监听doorList变化，设置默认选中项
    doorList: {
      handler(newDoorList) {
        if (newDoorList && newDoorList.length > 0) {
          // 设置楼层选择器的选项
          // 默认选择第一个选项
          if (!this.selectedDoorId && newDoorList.length > 0) {
            this.selectedDoorId = newDoorList[0].id;
          }
        } else {
          this.selectedDoorId = "";
        }
      },
      immediate: true,
    },
  },
  created() {
    this.startClock();
  },
  mounted() {
    this.initCharts();
    this.fetchAllData();
    this.startDataRefresh();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.dataRefreshTimer) {
      clearInterval(this.dataRefreshTimer);
    }
  },
  methods: {
    // 过滤下拉选项
    filterOptions() {
      const keyword = this.searchKeyword.toLowerCase();
      if (!keyword) {
        this.filteredOptions = [...this.communityData];
      } else {
        this.filteredOptions = this.communityData.filter((item) =>
          item.name.toLowerCase().includes(keyword)
        );
      }
    },

    // 选择下拉选项
    selectOption(item) {
      this.searchKeyword = item.name;
      this.showDropdown = false;
      this.$router.push({
        name: "homeTwo",
        params: { id: item.id },
        query: { name: item.name },
      });
    },

    // 关闭下拉框
    closeDropdown() {
      this.showDropdown = false;
    },

    // 处理楼层变更
    handleFloorChange(doorId) {
      console.log("楼层已切换到:", doorId);
      // 这里可以添加楼层切换后的额外逻辑，比如更新电梯状态等
    },

    // 处理头部楼层选择变化
    handleHeaderFloorChange() {
      console.log("头部选择楼层:", this.selectedDoorId);
    },

    // 确认头部楼层选择 - 控制电梯
    async confirmHeaderFloorSelection() {
      if (this.selectedDoorId) {
        console.log("头部确认选择楼层:", this.selectedDoorId);
        await this.controlElevator(this.selectedDoorId);
      } else {
        this.$message && this.$message.warning("请先选择楼层");
      }
    },

    // 控制电梯 - 调用opendevice接口
    async controlElevator(doorId) {
      if (!doorId) {
        this.$message && this.$message.warning("请选择楼层");
        return;
      }

      try {
        // 调用控制电梯接口
        const response = await dashboardAPI.getOpendevice({ door_id: doorId });

        if (response && response.code === 1) {
          // 成功提示
          this.$message && this.$message.success(response.msg || "远程开门成功");
        } else {
          // 失败提示 - 处理各种可能的返回格式
          const errorMsg = response
            ? response.msg || `操作失败，错误码: ${response.code}`
            : "操作失败，无响应数据";
          this.$message && this.$message.error("操作失败: " + errorMsg);
        }
      } catch (error) {
        console.error("控制电梯失败:", error);
        // 异常时也显示错误提示
        this.$message && this.$message.error("网络错误，请稍后重试");
      }
    },

    // 获取所有数据
    async fetchAllData() {
      try {
        // 计算时间范围（默认获取本月数据）
        const today = new Date();
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const starttime = this.formatDate(startOfMonth);
        const endtime = this.formatDate(today);

        // 从路由获取id参数
        const id = this.$route.params.id;

        // 调用真实API，带id参数
        const params = { starttime, endtime };
        if (id) {
          params.id = id;
        }
        const response = await dashboardAPI.getCommunityInfo(params.id);

        // 保存原始数据
        this.apiData = response;

        this.doorList = response.data.door_list.doorList;

        // 解析并映射数据到页面
        this.parseApiData(response);

        // 更新图表数据
        this.updateCharts();

      } catch (error) {
        console.error("API数据获取失败:", error);
        // API请求失败时不使用模拟数据
        console.warn("数据加载失败，请检查网络连接或API服务");
      }
    },

    // 解析API返回的数据
    parseApiData(response) {
      // 根据实际API返回的数据结构进行映射
      const data = response.data || response;

      // 电梯统计数据
      // API字段: year_event_total, last_year_event_total, event_total
      this.elevatorStats = {
        total: this.barChartData.reduce((sum, item) => sum + item.value, 0) || 0, // 项目总数从区域统计计算
        thisYearMaintenance: data.year_event_total || 0,
        lastYearMaintenance: data.last_year_event_total || 0,
        totalEvents: data.event_total || 0,
      };

      // 饼图数据 - 事件类型分析
      // API字段: event_by_type [{event, num, event_name}]
      if (data.event_by_type && Array.isArray(data.event_by_type)) {
        const colors = [
          "#00d4ff",
          "#ffaa00",
          "#00ff88",
          "#ff3366",
          "#9966ff",
          "#ff6699",
          "#66ccff",
          "#ffcc00",
          "#00ffcc",
          "#ff9933",
          "#cc66ff",
        ];
        this.pieChartData = data.event_by_type.map((item, index) => ({
          value: item.num || 0,
          name: item.event_name || "",
          itemStyle: { color: colors[index % colors.length] },
        }));
      }

      // 柱状图数据 - 区域项目统计
      // API字段: community_area [{num, name}]
      if (data.community_area && Array.isArray(data.community_area)) {
        this.barChartData = data.community_area.map((item) => ({
          name: item.name || "",
          value: item.num || 0,
        }));
        // 更新项目总数
        this.elevatorStats.total = this.barChartData.reduce(
          (sum, item) => sum + item.value,
          0
        );
      }

      // 电梯实时状态数据
      // API字段: community_now {floor, direction, flatStatus, speed, runCount, doorCount, mileage, runTime}
      if (data.community_now[0]) {
        this.communityNow = data.community_now[0];
      } else {
        // 使用默认值
        this.communityNow = {};
      }

      // 项目列表数据（下拉框数据源）
      // API字段: community_data [{id, name, qiniu_flv, ...}]
      // if (data.community_data) {
      if (data.community_data && Array.isArray(data.community_data)) {
        this.communityData = data.community_data.map((item) => ({
          id: item.id,
          name: item.name || "",
        }));
        // 初始化下拉选项
        this.filteredOptions = [...this.communityData];

        // 根据路由id找到对应项，获取视频URL和设备信息
        const id = this.$route.params.id;
        if (id) {
          // const currentItem = data.community_data;
          const currentItem = data.community_data.find(
            (item) => String(item.id) === String(id)
          );
          if (currentItem) {
            // 设置视频流URL（优先使用flv格式）
            this.videoUrl =
              currentItem.qiniu_flv ||
              currentItem.qiniu_hls ||
              currentItem.qiniu_rtmp ||
              "";

            // 设置设备信息
            this.deviceInfo = {
              // name: currentItem.name,
              // devid: currentItem.devid,
              device_code: currentItem.device_code,
              elevator_sign: currentItem.elevator_sign,
              elevator_number: currentItem.elevator_number,
              elevator_unit: currentItem.elevator_unit,
              elevator_model: currentItem.elevator_model,
              elevator_layer: currentItem.elevator_layer,
              inspection_organization: currentItem.inspection_organization,
              audittimes: currentItem.audittimes,
              // crontab_time: currentItem.crontab_time
            };
          }
        }
      }

      // 折线图数据 - 缴费统计
      // API字段: fee_data [{num, name}]
      if (data.fee_data && Array.isArray(data.fee_data)) {
        this.lineChartData = data.fee_data.map((item) => ({
          name: item.name || "",
          value: item.num || 0,
        }));
      }

      // 横向柱状图数据 - 维保单位统计
      // API字段: wb_unit [{wb_name, num}]
      if (data.wb_unit && Array.isArray(data.wb_unit)) {
        this.barHorizontalChartData = data.wb_unit
          .filter((item) => item.wb_name && item.wb_name !== "-") // 过滤掉无效数据
          .map((item) => ({
            name: item.wb_name || "",
            value: item.num || 0,
          }))
          .sort((a, b) => b.value - a.value); // 按数量降序排列
      }

      // 维保作业记录
      // API字段: wb_list [{wb_time, wb_cycle, wb_system, workerList}]
      if (data.wb.list && Array.isArray(data.wb.list)) {
        this.maintenanceRecords = data.wb.list.map((item) => {
          const record = {
            id: item.id || "",
            date: item.updateTime || "",
            cycle: item.wbzqTypeName || "",
            system: item.maintenanceUnitName || "",
            staff: this.formatWorkerList(item.workerList),
            maintenanceItemName: item.maintenanceItemName || item.system || "", // 维保项名称
            remark: item.remark || "", // 备注
            experimentResult: item.experimentResult || "", // 实验结果
          };
          // 只有当fwbgId存在且不为空时才添加到记录中（注意：API返回的是fwbgId，不是fwbgld）
          if (item.fwbgId && item.fwbgId !== "") {
            record.fwbgld = item.fwbgId;
          }
          return record;
        });
      }

      // 报警记录
      // API字段: event_data [{event, createtime, devid, event_name, community_name, picture_file}]
      if (data.event_data && Array.isArray(data.event_data)) {
        this.alarmRecords = data.event_data.map((item) => ({
          createtime: item.createtime || "",
          event_name: item.event_name || "",
          community_name: item.community_name || "",
          picture_file: item.picture_file || "",
          devid: item.devid || "",
          eventid: item.eventid || "",
          event: item.event || "",
        }));
      }

      // 维保计划
      // API字段: wb_data {maintenanceUnitName, unattendedPhone, latestMaintenanceDate, shouldMaintenanceDate, communityName, maintenanceWorkerName1, maintenanceWorkerName2}
      if (data.wb_data) {
        this.maintenancePlans = [data.wb_data].map((plan) => ({
          unit_name: plan.maintenanceUnitName || "",
          phone: plan.unattendedPhone || "",
          number: plan.equipmentCode || "",
          last_maintenance: plan.latestMaintenanceDate || "",
          next_maintenance: plan.shouldMaintenanceDate || "",
          communityName: plan.communityName || "",
          maintenanceWorkerName1: plan.maintenanceWorkerName1 || "",
          maintenanceWorkerName2: plan.maintenanceWorkerName2 || "",
        }));
      }

      // 工单记录
      if (data.inspection_order && Array.isArray(data.inspection_order)) {
        this.workOrderRecords = data.inspection_order.map((item) => ({
          id: item.id ?? "",
          areaId: item.area_id ?? "",
          areaSiteId: item.area_site_id ?? "",
          code: item.code ?? "",
          createTime: item.createtime ?? "",
          completeTime: item.completetime ?? "",
          // content: item.content ?? "",
          eventId: item.eventid ?? "",
          urgency: item.level ?? "",
          orderType: item.order_type_text ?? item.order_type ?? "",
          repairContent: item.repair_content ?? "",
          repairImage: item.repair_images ?? "",
          staffId: item.staff_id ?? "",
          responsibleEmployee: item.repair_staff_id ?? "",
          status: item.status_text ?? item.status ?? "",
          title: item.title ?? "",
          orderImage: item.images ?? "",
          reportEmployee: item.staff_id ?? "",
          orderEvent: item.content ?? "",
          communityAddress: item.area_id ?? "",
        }));
      } else {
        this.workOrderRecords = [];
      }
    },

    // 初始化所有图表
    initCharts() {
      this.$nextTick(() => {
        this.charts.pie = echarts.init(document.getElementById("pieChart"));
        // this.charts.bar = echarts.init(document.getElementById('barChart'));
        // this.charts.line = echarts.init(document.getElementById('lineChart'));
      });
    },

    // 更新所有图表数据
    updateCharts() {
      this.updatePieChart();
      // this.updateBarChart();
      // this.updateLineChart();
    },

    // 更新饼图
    updatePieChart() {
      if (!this.charts.pie) return;

      // 如果没有数据，显示空状态
      if (!this.pieChartData || this.pieChartData.length === 0) {
        this.charts.pie.setOption({
          title: {
            text: "暂无数据",
            left: "center",
            top: "center",
            textStyle: {
              color: "#88c4ff",
              fontSize: 14,
            },
          },
        });
        return;
      }

      // 为每个数据项设置标签和连接线颜色
      const processedData = this.pieChartData.map((item) => ({
        ...item,
        label: {
          color: item.itemStyle?.color || "#00d4ff",
          fontSize: 11,
          fontWeight: "bold",
          lineHeight: 14,
          textShadowColor: "rgba(0, 0, 0, 0.8)",
          textShadowBlur: 3,
          textShadowOffsetX: 1,
          textShadowOffsetY: 1,
        },
        labelLine: {
          lineStyle: {
            color: item.itemStyle?.color || "#00d4ff",
            width: 1.5,
            type: "solid",
          },
        },
      }));

      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          borderColor: "#00d4ff",
          textStyle: { color: "#fff" },
        },
        series: [
          {
            name: "事件分析",
            type: "pie",
            radius: ["45%", "75%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 5,
              borderColor: "#0a1929",
              borderWidth: 2,
            },
            label: {
              show: true,
              position: "outside",
              formatter: function (params) {
                // 如果名称太长，进行截断
                const name =
                  params.name.length > 4
                    ? params.name.substring(0, 4) + "..."
                    : params.name;
                return name + "\n" + params.percent + "%";
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "14",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
              length: 12,
              length2: 8,
              smooth: 0.3,
            },
            data: processedData,
          },
        ],
        graphic: [
          {
            type: "text",
            left: "center",
            top: "42%",
            style: {
              text: "事件分析",
              textAlign: "center",
              fill: "#00d4ff",
              fontSize: 16,
              fontWeight: "bold",
            },
          },
          {
            type: "text",
            left: "center",
            top: "58%",
            style: {
              text: "百分比",
              textAlign: "center",
              fill: "#88c4ff",
              fontSize: 12,
            },
          },
        ],
      };
      this.charts.pie.setOption(option);
    },

    // 更新柱状图
    updateBarChart() {
      if (!this.charts.bar) return;
      const maxValue = Math.max(...this.barChartData.map((item) => item.value), 100);
      const yAxisMax = Math.ceil(maxValue / 20) * 20 + 20;

      const option = {
        title: {
          text: "中心区域项目数量统计",
          textStyle: { color: "#00d4ff", fontSize: 14 },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          borderColor: "#00d4ff",
          textStyle: { color: "#fff" },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.barChartData.map((item) => item.name),
          axisTick: { alignWithLabel: true },
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff", fontSize: 10 },
        },
        yAxis: {
          type: "value",
          name: "数量",
          min: 0,
          max: yAxisMax,
          interval: 20,
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff" },
          splitLine: { lineStyle: { color: "rgba(0, 212, 255, 0.2)" } },
        },
        series: [
          {
            data: this.barChartData.map((item) => item.value),
            type: "bar",
            barWidth: "50%",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00d4ff" },
                { offset: 1, color: "#0088cc" },
              ]),
              borderRadius: [4, 4, 0, 0],
            },
            label: {
              show: true,
              position: "inside",
              color: "#fff",
              fontSize: 12,
              fontWeight: "bold",
              formatter: "{c}",
            },
          },
        ],
      };
      this.charts.bar.setOption(option);
    },

    // 更新折线图
    updateLineChart() {
      if (!this.charts.line) return;
      const option = {
        title: {
          text: "每月自主缴费记录统计",
          textStyle: { color: "#00d4ff", fontSize: 14 },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          borderColor: "#00d4ff",
          textStyle: { color: "#fff" },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.lineChartData.map((item) => item.name),
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff", fontSize: 10 },
        },
        yAxis: {
          type: "value",
          name: "数量",
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff" },
          splitLine: { lineStyle: { color: "rgba(0, 212, 255, 0.2)" } },
        },
        series: [
          {
            data: this.lineChartData.map((item) => item.value),
            type: "line",
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(0, 212, 255, 0.4)" },
                { offset: 1, color: "rgba(0, 212, 255, 0.1)" },
              ]),
            },
            lineStyle: {
              color: "#00d4ff",
              width: 2,
            },
            itemStyle: {
              color: "#00d4ff",
              borderColor: "#fff",
              borderWidth: 2,
            },
          },
        ],
      };
      this.charts.line.setOption(option);
    },

    // 更新横向柱状图
    updateBarHorizontalChart() {
      if (!this.charts.barHorizontal) return;

      // 反转数据顺序，让数值大的显示在上面
      const sortedData = [...this.barHorizontalChartData].reverse();

      // 动态计算X轴最大值
      const maxValue = Math.max(
        ...this.barHorizontalChartData.map((item) => item.value),
        100
      );
      const xAxisMax = Math.ceil(maxValue / 50) * 50 + 20;

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          borderColor: "#00d4ff",
          textStyle: { color: "#fff" },
        },
        grid: {
          left: "15%",
          right: "10%",
          bottom: "3%",
          top: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          max: xAxisMax,
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff" },
          splitLine: { lineStyle: { color: "rgba(0, 212, 255, 0.2)" } },
        },
        yAxis: {
          type: "category",
          data: sortedData.map((item) => item.name),
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff", fontSize: 10 },
        },
        series: [
          {
            data: sortedData.map((item) => item.value),
            type: "bar",
            barWidth: "60%",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: "#0088cc" },
                { offset: 1, color: "#00d4ff" },
              ]),
              borderRadius: [0, 4, 4, 0],
            },
            label: {
              show: true,
              position: "inside",
              color: "#fff",
              fontSize: 12,
              fontWeight: "bold",
              formatter: "{c}",
            },
          },
        ],
      };
      this.charts.barHorizontal.setOption(option);
    },

    // 更新时间
    startClock() {
      this.updateTime();
      this.timer = setInterval(() => {
        this.updateTime();
      }, 1000);
    },

    updateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 定时刷新数据
    startDataRefresh() {
      this.dataRefreshTimer = setInterval(() => {
        this.fetchAllData();
      }, 60000); // 每60秒刷新一次数据
    },

    // 格式化日期为 YYYY-MM-DD
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // 格式化维保人员列表
    formatWorkerList(workerList) {
      if (!workerList || !Array.isArray(workerList) || workerList.length === 0) {
        return "";
      }
      return workerList
        .map((worker) => {
          const name = worker.maintenanceWorkerName || "";
          const phone = worker.maintenanceWorkerPhone || "";
          return phone ? `${name}(${phone})` : name;
        })
        .filter((item) => item)
        .join("、");
    },

    // 日期选择变化
    onDateChange() {
      console.log("选择日期:", this.selectedDate);
      this.selectedFilter = "custom";
      this.fetchDataByDate(this.selectedDate);
    },

    // 根据日期获取数据
    async fetchDataByDate(date, filterType = "custom") {
      console.log(`获取 ${date} 的数据，筛选类型: ${filterType}`);

      try {
        // 计算时间范围
        let starttime, endtime;
        const selectedDate = new Date(date);

        switch (filterType) {
          case "today":
            starttime = date;
            endtime = date;
            break;
          case "yesterday":
            starttime = date;
            endtime = date;
            break;
          case "week":
            // 本周数据
            const dayOfWeek = selectedDate.getDay();
            const diff = selectedDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
            const weekStart = new Date(selectedDate);
            weekStart.setDate(diff);
            starttime = this.formatDate(weekStart);
            endtime = this.formatDate(new Date());
            break;
          case "month":
            // 本月数据
            const monthStart = new Date(
              selectedDate.getFullYear(),
              selectedDate.getMonth(),
              1
            );
            starttime = this.formatDate(monthStart);
            endtime = this.formatDate(new Date());
            break;
          default:
            // 自定义日期，获取当天数据
            starttime = date;
            endtime = date;
        }

        console.log(`API请求时间范围: ${starttime} 至 ${endtime}`);

        // 从路由获取id参数
        const id = this.$route.params.id;

        // 调用真实API，带id参数
        const params = { starttime, endtime };
        if (id) {
          params.id = id;
        }
        const response = await dashboardAPI.getScreenData(params);
        console.log("API返回数据:", response);

        // 解析数据
        this.parseApiData(response);
      } catch (error) {
        console.error("获取数据失败:", error);
        // API请求失败时不使用模拟数据
        console.warn("数据加载失败，请检查网络连接或API服务");
      }

      // 更新图表数据
      this.updateCharts();
    },

    // 返回主页
    goToHome() {
      this.$router.push({ name: "home" });
    },
  },
};
</script>

<style scoped lang="less">
.dashboard-container {
  background: linear-gradient(135deg, #0a1929 0%, #1a2332 50%, #0e2a42 100%);
  color: white;
  font-family: "Microsoft YaHei", sans-serif;
  min-height: 100vh;
  padding: 15px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.dashboard-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(
      circle at 20% 20%,
      rgba(0, 212, 255, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(circle at 80% 80%, rgba(0, 212, 255, 0.1) 0%, transparent 50%);
  pointer-events: none;
  z-index: 1;
}

.dashboard-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: repeating-linear-gradient(
      90deg,
      transparent,
      transparent 98px,
      rgba(0, 212, 255, 0.03) 100px
    ),
    repeating-linear-gradient(
      0deg,
      transparent,
      transparent 98px,
      rgba(0, 212, 255, 0.03) 100px
    );
  pointer-events: none;
  z-index: 1;
}

.dashboard-container > * {
  position: relative;
  // z-index: 2;
}

.header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.1), transparent);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
}

.header::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.2), transparent);
  animation: headerScan 3s infinite;
}

.header-left,
.header-right {
  display: flex;
  gap: 8px;
  align-items: center;
}

// 返回主页按钮样式
.back-home-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #00d4ff;
  font-size: 12px;
  margin-right: 10px;
}

// 电梯楼层显示样式
.elevator-floor-display {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 5px;
  margin-left: 10px;
}

.floor-label {
  font-size: 12px;
  color: #88c4ff;
}

.floor-value {
  font-size: 12px;
  color: #00d4ff;
  font-weight: bold;
}

.back-home-btn:hover {
  background: rgba(0, 212, 255, 0.2);
  border-color: #00d4ff;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
  transform: translateX(-2px);
}

.back-icon {
  font-size: 14px;
  font-weight: bold;
  color: #00d4ff;
}

.back-text {
  font-size: 12px;
  color: #00d4ff;
}

.header-left {
  .search-dropdown {
    position: relative;
    display: flex;
    align-items: center;
    background: rgba(0, 212, 255, 0.1);
    border: 1px solid rgba(0, 212, 255, 0.3);
    border-radius: 5px;
    padding: 8px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      border-color: #00d4ff;
      box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
    }

    .search-input {
      background: transparent;
      border: none;
      outline: none;
      color: #fff;
      font-size: 12px;
      width: 260px;

      &::placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
    }

    .dropdown-icon {
      font-size: 10px;
      color: #00d4ff;
      margin-left: 5px;
    }

    .dropdown-list {
      position: absolute;
      top: 100%;
      left: 0;
      min-width: 300px;
      margin-top: 5px;
      background: rgba(10, 25, 41, 0.98);
      border: 1px solid rgba(0, 212, 255, 0.5);
      border-radius: 5px;
      max-height: 300px;
      overflow-y: auto;
      z-index: 9999;
      box-shadow: 0 4px 15px rgba(0, 212, 255, 0.3);

      .dropdown-item {
        padding: 10px 12px;
        font-size: 12px;
        color: #fff;
        cursor: pointer;
        transition: all 0.2s;
        border-bottom: 1px solid rgba(0, 212, 255, 0.1);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background: rgba(0, 212, 255, 0.2);
          color: #00d4ff;
        }
      }
    }
  }
}

.header-right {
  align-items: flex-end;
  display: flex;
  align-items: center;
}

@keyframes headerScan {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

.title {
  font-size: 24px;
  font-weight: bold;
  color: #00d4ff;
  text-shadow: 0 0 20px rgba(0, 212, 255, 0.8);
  letter-spacing: 2px;
  position: relative;
}

.title::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

.project-total,
.current-time {
  font-size: 14px;
  color: #ffffff;
  background: rgba(0, 212, 255, 0.1);
  padding: 6px 12px;
  border-radius: 5px;
  border: 1px solid rgba(0, 212, 255, 0.3);
  position: relative;
  overflow: hidden;
}

.project-total::before,
.current-time::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

/* 楼层选择器样式 */
.floor-selector-header {
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.floor-control-group-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.custom-select-header {
  position: relative;
  display: inline-block;
}

.floor-dropdown-header {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.5);
  border-radius: 5px;
  color: #00d4ff;
  padding: 5px 25px 5px 10px;
  font-size: 12px;
  min-width: 100px;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;
}

.floor-dropdown-header:hover {
  background: rgba(0, 212, 255, 0.2);
  border-color: #00d4ff;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.3);
}

.floor-dropdown-header:focus {
  border-color: #00d4ff;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
}

.select-arrow-header {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  color: #00d4ff;
  font-size: 10px;
  pointer-events: none;
  transition: transform 0.3s ease;
}

.custom-select-header:hover .select-arrow-header {
  transform: translateY(-50%) scale(1.1);
}

.confirm-btn-header {
  background: rgba(0, 212, 255, 0.2);
  border: 1px solid rgba(0, 212, 255, 0.5);
  border-radius: 5px;
  color: #00d4ff;
  padding: 5px 15px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.confirm-btn-header:hover:not(:disabled) {
  background: rgba(0, 212, 255, 0.3);
  border-color: #00d4ff;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.3);
}

.confirm-btn-header:active:not(:disabled) {
  transform: translateY(1px);
}

.confirm-btn-header:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: rgba(0, 212, 255, 0.1);
}

/* 时间检索组件样式 */
.time-filter {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.filter-label {
  font-size: 14px;
  color: #88c4ff;
  white-space: nowrap;
}

.date-picker-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-picker {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 5px;
  padding: 6px 10px;
  color: #ffffff;
  font-size: 12px;
  outline: none;
  transition: all 0.3s;
}

.date-picker:focus {
  border-color: #00d4ff;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.date-picker::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
}

.quick-filters {
  display: flex;
  gap: 5px;
}

.quick-btn {
  background: rgba(0, 136, 204, 0.3);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 4px;
  padding: 4px 8px;
  color: #88c4ff;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.quick-btn:hover {
  background: rgba(0, 212, 255, 0.2);
  color: #00d4ff;
  border-color: #00d4ff;
}

.quick-btn.active {
  background: rgba(0, 212, 255, 0.3);
  color: #00d4ff;
  border-color: #00d4ff;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.4);
}

.time::before,
.project-total::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

.main-content {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  height: 500px;
  align-items: stretch;
  /* 确保所有列等高 */
}

.left-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 100%;
}

.stats-pie-container {
  display: flex;
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  height: 220px;
  /* 固定高度 */
  position: relative;
  overflow: hidden;
}

.stats-pie-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

.chart-container {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 0 15px 15px;
  box-sizing: border-box;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  flex: 1;
  min-height: 120px;
  /* 最小高度 */
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.chart-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

.center-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.right-section {
  flex: 1;
  height: 100%;
}

.stat-details {
  // flex: 1;
  width: 120px;
  padding-right: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.stat-item {
  margin-bottom: 8px;
  padding: 8px;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.1), rgba(0, 136, 204, 0.1));
  border-radius: 8px;
  border-left: 3px solid #00d4ff;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-item:last-child {
  margin-bottom: 0;
}

.stat-number {
  font-size: 22px;
  font-weight: bold;
  color: #00d4ff;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
  line-height: 1;
}

.stat-desc {
  font-size: 11px;
  color: #88c4ff;
  margin-top: 3px;
  line-height: 1.2;
}

.pie-chart-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
}

// 电梯实时状态监控样式
.elevator-status-container {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.elevator-status-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

.elevator-status-title {
  font-size: 16px;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
  // margin-bottom: 15px;
}

.elevator-status-content {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  padding: 10px;
}

.elevator-status-item {
  padding: 5px;
  background: linear-gradient(135deg, rgba(0, 136, 204, 0.1), rgba(0, 68, 102, 0.1));
  border-radius: 8px;
  border-left: 3px solid #00d4ff;
  flex: 1;
  display: flex;
  // flex-direction: column;
  justify-content: center;
}

.elevator-label {
  color: #88c4ff;
  font-size: 12px;
  margin-bottom: 5px;
}

.elevator-value {
  color: #00d4ff;
  font-size: 14px;
  font-weight: bold;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
  line-height: 1.2;
}

// 3D电梯模型样式
.elevator-3d {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 1000px;
}

.elevator-svg-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(10, 25, 41, 0.3);
  // border-radius: 15px;
  // border: 1px solid rgba(0, 212, 255, 0.3);
  // box-shadow:
  //   0 0 30px rgba(0, 212, 255, 0.2),
  //   inset 0 0 30px rgba(0, 212, 255, 0.1);
}

.elevator-svg {
  width: 100%;
  height: 100%;
  // filter: drop-shadow(0 0 10px rgba(0, 212, 255, 0.5));
}

// 维保作业样式
.maintenance-records {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.work-order-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid rgba(0, 212, 255, 0.5);
  margin-bottom: 10px;
}

.work-order-header .header-item {
  font-weight: bold;
  color: #00d4ff;
  flex: 1;
  text-align: center;
  font-size: 13px;
}

.work-order-table {
  flex: 1;
  overflow-y: auto;
}

.work-order-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.3s;
}

.work-order-row:hover {
  background-color: rgba(0, 212, 255, 0.1);
}

.work-order-cell {
  color: #ffffff;
  font-size: 12px;
  flex: 1;
  text-align: center;
}

.work-order-cell:first-child {
  color: #00d4ff;
}

// 维保信息样式
.maintenance-plan-section {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  flex: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.maintenance-plan-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

.maintenance-plan-title {
  font-size: 16px;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
  margin-bottom: 15px;
}

.maintenance-content {
  // height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 10px;
}

.maintenance-item {
  padding: 8px 12px;
  background: linear-gradient(135deg, rgba(0, 136, 204, 0.1), rgba(0, 68, 102, 0.1));
  border-radius: 8px;
  border-left: 3px solid #00d4ff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 40px;
}

.maintenance-label {
  color: #88c4ff;
  font-size: 11px;
  margin-bottom: 3px;
  line-height: 1.2;
}

.maintenance-value {
  color: #00d4ff;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 0 0 8px rgba(0, 212, 255, 0.5);
  line-height: 1.2;
  word-break: break-all;
}

.bottom-section {
  display: flex;
  gap: 20px;
  height: 350px;
}

.line-chart-section {
  flex: 1;
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 0 15px 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  box-sizing: border-box;
}

.alarm-records {
  flex: 1;
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
}

.maintenance-records {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.maintenance-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid rgba(0, 212, 255, 0.5);
  margin-bottom: 10px;
}

.maintenance-header .header-item {
  font-weight: bold;
  color: #00d4ff;
  flex: 1;
  text-align: center;
  font-size: 13px;
}

.maintenance-table {
  flex: 1;
  overflow-y: auto;
}

.maintenance-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.3s;
}

.maintenance-row:hover {
  background-color: rgba(0, 212, 255, 0.1);
}

.maintenance-cell {
  color: #ffffff;
  font-size: 12px;
  flex: 1;
  text-align: center;
}

.maintenance-cell:first-child {
  color: #00d4ff;
}

.record-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid rgba(0, 212, 255, 0.5);
  margin-bottom: 10px;
}

.header-item {
  font-weight: bold;
  color: #00d4ff;
  flex: 1;
  text-align: center;
}

.record-table {
  height: 270px;
  overflow-y: auto;
}

.record-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.3s;
}

.record-row:hover {
  background-color: rgba(0, 212, 255, 0.1);
}

.record-time {
  color: #00d4ff;
  font-size: 12px;
  flex: 1;
  text-align: center;
}

.record-type {
  color: #ffaa00;
  font-size: 12px;
  flex: 1;
  text-align: center;
}

.record-location {
  color: #ffffff;
  font-size: 12px;
  flex: 2;
  text-align: center;
}

.platform-buttons {
  flex: 1;
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
}

.platform-title {
  font-size: 16px;
  margin-bottom: 15px;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
}

.button-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  height: 190px;
  overflow-y: auto;
}

.platform-button {
  background: linear-gradient(135deg, rgba(0, 136, 204, 0.8), rgba(0, 68, 102, 0.8));
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 5px;
  padding: 8px;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s;
  font-size: 12px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platform-button:hover {
  background: linear-gradient(135deg, #00d4ff, #0088cc);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.4);
}

// 设备信息样式
.device-info {
  flex: 1;
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  position: relative;
  overflow-y: auto;
}

.device-info::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

.device-title {
  font-size: 16px;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
  margin-bottom: 15px;
}

.device-content {
  // height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 10px;
}

.device-item {
  padding: 8px 12px;
  background: linear-gradient(135deg, rgba(0, 136, 204, 0.1), rgba(0, 68, 102, 0.1));
  border-radius: 8px;
  border-left: 3px solid #00d4ff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 40px;
}

.device-label {
  color: #88c4ff;
  font-size: 11px;
  margin-bottom: 3px;
  line-height: 1.2;
}

.device-value {
  color: #00d4ff;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 0 0 8px rgba(0, 212, 255, 0.5);
  line-height: 1.2;
  word-break: break-all;
}

.device-empty {
  height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #88c4ff;
  font-size: 14px;
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 212, 255, 0.5);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 212, 255, 0.8);
}
</style>
